module.exports = __webpack_public_path__ + "media/images/channels/surgery-26475991d1ba5aa3341bd448b162626c.jpg";